import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import {
  type DocumentCategory,
  DocumentSignatureService,
  type IDocumentSignatureService,
} from '../../../../services/document-signature/document-signature.service';

export const tenantDocumentsQueryKeys = {
  all: ['tenant-documents'] as const,
  list: (category?: string) => ['tenant-documents', category ?? 'all'] as const,
};

export function useTenantDocuments(category?: DocumentCategory) {
  const service = useInjection<IDocumentSignatureService>(DocumentSignatureService);

  const {
    data: documents = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: tenantDocumentsQueryKeys.list(category),
    queryFn: () => service.findAllByTenant(category),
  });

  return { documents, isLoading, error };
}
